export default [
  {
    path: '/activity-20260817-main',
    component: () => import('./Page.vue'),
    meta: { title: '七夕长相思守', id: 39 },
  },
  {
    path: '/activity-20260817-rule',
    component: () => import('./Rule.vue'),
    meta: { title: '七夕长相思守-规则', id: 39 },
  },
]
